import en from './locales/en.json';
import zh from './locales/zh.json';
import fr from './locales/fr.json';

const messages = {
  en,
  zh,
  fr,
};

const langCode2Name = {
  en: 'English',
  zh: '简体中文',
  fr: 'Français',
};

export default {
  messages,
  langCode2Name,
};
